import { render, staticRenderFns } from "./EditSpokespersonModal.vue?vue&type=template&id=717ae30a&"
import script from "./EditSpokespersonModal.vue?vue&type=script&lang=js&"
export * from "./EditSpokespersonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717ae30a')) {
      api.createRecord('717ae30a', component.options)
    } else {
      api.reload('717ae30a', component.options)
    }
    module.hot.accept("./EditSpokespersonModal.vue?vue&type=template&id=717ae30a&", function () {
      api.rerender('717ae30a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/EditSpokespersonModal.vue"
export default component.exports